import script from "./POIItem.vue?vue&type=script&setup=true&lang=js"
export * from "./POIItem.vue?vue&type=script&setup=true&lang=js"

import "./POIItem.vue?vue&type=style&index=0&id=323113a6&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/RJKESzs2/0/roolz/poi-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-323113a6"]])

export default __exports__